<button (click)="goBack()" mat-raised-button class="btn" style="margin-bottom: 24px;">
  <mat-icon>chevron_left</mat-icon>
  {{ 'BACK_TO_CAMERA_SUPERVISION' | translate }}
</button>
<div
  class="container d-flex align-datas-center justify-content-center"
  style="width: 80%">
  <div style="width: 100%" class="mb-3">
    <h3 class="mb-5">{{ "CAMERA_CONFIGURATION" | translate }}</h3>

    <div class="mb-3">
      <button class="btn btn-primary" (click)="showNewGroupForm.next(true)" [class.restrictor]="!(Areas.Cameras | can: 'ReadWrite')">
        <span class="fa-light fa-fw fa-plus"></span>
        {{ "NEW_CAMERA_GROUP" | translate }}
      </button>

      <input
        [hidden]="!pageDataLoaded"
        type="text"
        class="form-control border border-secondary float-right"
        style="width: 30%"
        placeholder="{{ 'SEARCH' | translate }}..."
        #searchInput
        />
      </div>

      @if (showNewGroupForm.value) {
        <camera-group-form
          mode="add"
          [showForm]="showNewGroupForm"
          [isNightowlServiceCustomerIdSet]="nightowlServiceCustomerIdSet"
          [alertDeviceSelect]="alertDeviceSelect"
          [receiverTeamSelect]="receiverTeamSelect"
          [locationSelect]="locationSelect"
          [origonSelect]="origonSelect"
          [cameraList]="cameraList"
          [deviceTypeByDeviceId]="deviceTypeByDeviceId"
          [assignedCameras]="assignedCameras"
          (cameraGroupChanged)="refreshCameraGroups($event)">
        </camera-group-form>
      }

      @if (showEditForm.value) {
        <camera-group-form
          mode="edit"
          [showForm]="showEditForm"
          [existingGroup]="cameraGroupDataToEdit.cameraGroup"
          [existingVisitConfig]="cameraGroupDataToEdit.visitConfig"
          [alertDeviceSelect]="alertDeviceSelect"
          [receiverTeamSelect]="receiverTeamSelect"
          [locationSelect]="locationSelect"
          [origonSelect]="origonSelect"
          [cameraList]="cameraList"
          [deviceTypeByDeviceId]="deviceTypeByDeviceId"
          [assignedCameras]="assignedCameras"
          (cameraGroupChanged)="refreshCameraGroups($event)">
        </camera-group-form>
      }

      @if (successMsg) {
        <div class="alert alert-success" role="alert" [@fadeOut]>
          {{ successMsg | translate }}
        </div>
      }

      @if (warningMsg) {
        <div class="alert alert-danger" role="alert" [@fadeOut]>
          {{ warningMsg | translate }}
        </div>
      }

      <div class="card">
        <div
          class="card-header-white"
          style="border-bottom: 1px solid rgba(0, 0, 0, 0.1) !important"
          >
          <h6 class="white-header-text">
            {{ "CAMERA_GROUPS" | translate }}
          </h6>
        </div>

        <mat-accordion displayMode="flat" multi class="mat-table">
          @if (cameraGroups && pageDataLoaded) {
            @for (data of filteredCameraGroups; track data; let i = $index) {
              <mat-expansion-panel
                [expanded]="$safeNavigationMigration(data?.panelExpanded)"
                [ngStyle]="{ 'border-top': i > 0 ? '1px solid rgba(0, 0, 0, .1)' : 'none'}"
                #panel
                >
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    <span innerHTML="{{ data.cameraGroup.displayName | highlight : search }}"></span>
                  </mat-panel-title>
                </mat-expansion-panel-header>
                @if (panel.expanded) {
                  <div class="pb-4">
                    <div class="row pb-3">
                      <div class="col">
                        @if (data.cameraGroup.deviceType) {
                          <div class="infoRow mb-1">
                            <strong>{{ "DEVICE_TYPE" | translate }}:</strong>&nbsp;
                            @if (data.cameraGroup.deviceType === 'Nightowl') {
                              <p>Nightowl</p>
                            }
                            @if (data.cameraGroup.deviceType !== 'Nightowl') {
                              <p>{{ "Digital Supervision" | translate }}</p>
                            }
                          </div>
                        }
                        @if (data.cameraGroup.displayName) {
                          <div class="infoRow mb-1">
                            <strong>{{ "GROUP_NAME" | translate}}:</strong>&nbsp;
                            <p innerHTML="{{ data.cameraGroup.displayName | highlight : search }}"></p>
                          </div>
                        }
                        @if (data.cameraGroup.address || data.cameraGroup.postCode || data.cameraGroup.postOffice) {
                          <div class="infoRow mb-1">
                            <strong>{{ "ADDRESS" | translate }}:</strong>&nbsp;
                            <p innerHTML="{{ data.cameraGroup | cameraGroupFullAddress | highlight : search }}"></p>
                          </div>
                        }
                        @if (data.cameraGroup.locationId) {
                          <div class="infoRow mb-1">
                            <strong>{{ "LOCATION" | translate }}:</strong>&nbsp;
                            <p innerHTML="{{ data.cameraGroup.locationId | locationName : locationSelect| highlight : search }}"></p>
                          </div>
                        }
                        @if (data.cameraGroup.timeZone) {
                          <div class="infoRow mb-1">
                            <strong>{{ "TIME_ZONE" | translate }}:</strong>&nbsp;
                            <p innerHTML="{{ data.cameraGroup.timeZone | highlight : search }}"></p>
                          </div>
                        }
                        <div class="infoRow mb-1">
                          <strong>{{ "ACCESS_MODE" | translate }}:</strong>&nbsp;
                          <p innerHTML="{{ data.cameraGroup.accessMode | accessModeLangCode | translate | highlight : search }}"></p>
                        </div>
                        @if (data.cameraGroup.deviceType !== 'Nightowl' && data.cameraGroup.origonId) {
                          <div class="infoRow mb-1">
                            <strong>{{ "ORIGON_CALL" | translate }}:</strong>&nbsp;
                            <p innerHTML="{{ data.cameraGroup.origonId | origonName : origonSelect | highlight : search }}"></p>
                          </div>
                        }
                        @if (!data.cameraGroup.accessMode && isCameraGroupCurrentlyPaused(data.cameraGroup)) {
                          <br />
                          <div class="infoRow mb-1">
                            <strong>{{ "CAMERA_GROUP_PAUSED" | translate }}</strong>
                            @if (data.cameraGroup.pauseStart) {
                              <strong>:</strong>
                            }
                          </div>
                          @if (data.cameraGroup.pauseStart) {
                            <div>
                              <p>{{ formatLocalDateTime(data.cameraGroup.pauseStart, data.cameraGroup) }} - {{ formatLocalDateTime(data.cameraGroup.pauseEnd, data.cameraGroup) }}</p>
                            </div>
                          }
                        }
                      </div>
                      <div class="col">
                        <div class="row">
                          <div class="col">
                            @if (Areas.Cameras | can: 'ReadWrite') {
                              <button
                                class="btn btn-outline-dark float-right"
                                (click)="setEditGroup(data)"
                                >
                                <span class="fa fa-edit"></span>{{ "MODIFY" | translate }}
                              </button>
                            }
                          </div>
                        </div>
                      </div>
                    </div>
                    @if (data.visitConfig || data.cameraGroup.userGroups.length > 0 || data?.cameraGroup?.cameras?.length > 0) {
                      <br />
                      <div class="row pt-1">
                        @if (data.cameraGroup.accessMode === 'visitOnAlert' && data.visitConfig) {
                          <div
                            class="col"
                            [ngClass]="{ rightBorder: data.cameraGroup.userGroups.length > 0 || data?.cameraGroup?.cameras?.length > 0 }"
                            >
                            <h6 class="pb-1">
                              <strong>
                                {{ "VISIT_CONFIGURATION" | translate }}
                              </strong>
                            </h6>
                            <div class="bordered-box w-100 py-2 mb-3">
                              <strong>
                                {{ "VISIT_TIME_MINUTES" | translate }}:
                              </strong>
                              <span class="ml-1"
                                innerHTML="{{ data.visitConfig.options.visitTimeMinutes.toString() | highlight: search }}">
                              </span>
                              <strong class="pl-4">
                                {{ "VISIT_GRACE_TIME_MINUTES" | translate }}:
                              </strong>
                              <span class="ml-1"
                                innerHTML="{{ data.visitConfig.options.visitGraceTimeMinutes.toString() | highlight : search }}">
                              </span>
                              <div class="topBorder mt-4 pb-2 pt-2">
                                <strong>{{ "ALERT_SOURCES" | translate }}:</strong>
                                <div class="mt-2 pt-1 pl-4">
                                  @for (device of data.visitConfig.alertSources; track device) {
                                    <div>
                                      <li>{{ device.deviceID | deviceName : alertDeviceSelect | highlight : search }}</li>
                                    </div>
                                  }
                                </div>
                              </div>
                              @if (data.cameraGroup.deviceType === 'Nightowl') {
                                <div class="topBorder mt-2 pt-2">
                                  <strong>{{ "ACTIVATIONS" | translate }}:</strong>
                                  <div class="mt-2 pt-1"></div>
                                  @if (getAlarmTypeLabels(data.visitConfig.eventsToTrig); as groups) {
                                    @for (group of groups; track group) {
                                      <div class="mt-2">
                                        <span class="text-muted">{{ group.groupName }}</span>
                                        <div class="pl-4">
                                          @for (label of group.labels; track label) {
                                            <li>{{ label }}</li>
                                          }
                                        </div>
                                      </div>
                                    }
                                  } @else {
                                    <span class="mt-2">{{ "ALL_ALERT_TYPES_SELECTED" | translate }}</span>
                                  }
                                </div>
                              }
                            </div>
                          </div>
                        }
                        @if (data.cameraGroup.userGroups.length > 0 || data?.cameraGroup?.cameras?.length > 0) {
                          <div class="col">
                            @if (data.cameraGroup.userGroups && data.cameraGroup.userGroups.length > 0) {
                              <h6 class="pb-1">
                                <strong>
                                  {{ "RECEIVER_TEAMS" | translate }}
                                </strong>
                              </h6>
                              <div class="bordered-box w-100 py-2 mb-3">
                                <div class="col-sm-12">
                                  @for (groupId of data.cameraGroup.userGroups; track groupId) {
                                    <li
                                      innerHTML="{{ groupId | receiverTeamName : receiverTeamSelect | highlight : search }}">
                                    </li>
                                  }
                                </div>
                              </div>
                            }
                            <ng-container *ngTemplateOutlet="camerasSection; context: { data: data }"></ng-container>
                          </div>
                        }
                      </div>
                    }
                    <ng-template #camerasSection let-data="data">
                      @if (data?.cameraGroup?.cameras?.length > 0) {
                        <h6 style="margin-bottom: 10px">
                          <strong>{{ "CAMERAS" | translate }}</strong>
                        </h6>
                        @for (camera of data.cameraGroup.cameras; track camera) {
                          <div class="bordered-box w-100 py-2 mb-3">
                            <p class="cameraName">
                              {{ camera.displayName || "-" }} @if (camera.discoveryName) {
                              <span>({{ camera.discoveryName }})</span>
                            }
                          </p>
                          @if (data.cameraGroup.deviceType !== 'Nightowl') {
                            <label class="custom-checkbox">
                              <input
                                type="checkbox"
                                name="motion-detection"
                                [checked]="camera.motionDetection.enabled"
                                [disabled]="!camera.motionDetection.enabled"
                                (click)="preventCheckboxClick($event)"
                                />
                                {{ "MOTION_DETECTION_IN_CAMERA" | translate }}
                              </label>
                            }
                            <label class="custom-checkbox pl-3">
                              <input
                                type="checkbox"
                                name="alert-visit"
                                (change)="toggleVisitWithAlert($event, camera)"
                                [disabled]="!camera.motionDetection.alertVisit"
                                [checked]="camera.motionDetection.alertVisit"
                                (click)="preventCheckboxClick($event)"
                                >
                                {{ "VISIT_WITH_ALERT" | translate }}
                              </label>
                              @if (data.cameraGroup.deviceType !== 'Nightowl') {
                                <label class="custom-checkbox pl-3">
                                  <input
                                    type="checkbox"
                                    name="snapshot"
                                    [disabled]="!camera.motionDetection.snapshot"
                                    [checked]="camera.motionDetection.snapshot"
                                    (click)="preventCheckboxClick($event)"
                                    >
                                    {{ "SNAPSHOT_WITH_ALERT" | translate }}
                                  </label>
                                }
                                @if (data.cameraGroup.deviceType !=='Nightowl') {
                                  <label class="custom-checkbox pl-3">
                                    <input
                                      type="checkbox"
                                      name="videoclip"
                                      [disabled]="!camera.motionDetection.videoclip"
                                      [checked]="camera.motionDetection.videoclip"
                                      (click)="preventCheckboxClick($event)"
                                      />
                                      {{ "VIDEOCLIP_WITH_ALERT" | translate }}
                                    </label>
                                  }
                                  @if (('AnonymizedCameraSupervision' | isFeatureEnabled) && data.cameraGroup.deviceType !=='Nightowl') {
                                    <label class="custom-checkbox">
                                      <input
                                        type="checkbox"
                                        name="anonymized-visit"
                                        [checked]="camera.anonymization"
                                        [disabled]="!camera.anonymization"
                                        (click)="preventCheckboxClick($event)"
                                        />
                                        <span>
                                          <i class="fa-solid fa-eye-slash"></i>
                                          {{ "ANONYMIZED_VISIT" | translate }}
                                        </span>
                                      </label>
                                      <label class="custom-checkbox pl-3">
                                        <input
                                          type="checkbox"
                                          name="clear-img-toggle"
                                          [disabled]="!camera.toggleAnonymization"
                                          [checked]="camera.toggleAnonymization"
                                          (click)="preventCheckboxClick($event)"
                                          />
                                          <span>
                                            <i class="fa-solid fa-eye"></i>
                                            {{ "TOGGLE_CLEAR_IMAGE" | translate }}
                                          </span>
                                        </label>
                                      }
                                      @if (user?.roleLevel >= 200 && data.cameraGroup.deviceType !=='Nightowl') {
                                        <label class="custom-checkbox">
                                          <input
                                            type="checkbox"
                                            name="motion-detection"
                                            [checked]="camera.restingPositionEnabled"
                                            [disabled]="!camera.restingPositionEnabled"
                                            (click)="preventCheckboxClick($event)"
                                            />
                                            {{ "CAMERA_IN_RESTING_POSITION" | translate }}
                                          </label>
                                        }
                                      </div>
                                    }
                                  }
                                </ng-template>
                              </div>
                            }
                          </mat-expansion-panel>
                        }
                      }

                      @if (!pageDataLoaded) {
                        <div class="loadingIconContainer">
                          <img class="fadeLoader logoSmall mx-auto d-block" src="assets/img/loading_logo.svg" />
                        </div>
                      }

                      @if (pageDataLoaded && !cameraGroups) {
                        <div>
                          <p class="mt-3 ml-3">
                            {{ "NO_CAMERA_GROUPS" | translate }}
                          </p>
                        </div>
                      }
                    </mat-accordion>
                  </div>
                </div>
              </div>
